var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChips(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 88,
    viewBox: "0 0 78 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 27.55,
    fill: "#CE1D00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M24.085 8.01L22.61 1.712c1.725-.402 3.51-.645 5.34-.712l.243 6.462c-1.408.05-2.78.238-4.108.548zM49.99 24.085l6.298-1.474c.402 1.726.645 3.51.712 5.34l-6.462.244c-.05-1.408-.238-2.78-.548-4.108zM33.915 49.99l1.474 6.298c-1.726.402-3.51.645-5.34.712l-.244-6.462c1.408-.05 2.78-.238 4.108-.548zM8.01 33.915L1.712 35.39c-.402-1.725-.645-3.51-.712-5.34l6.462-.243c.05 1.408.238 2.78.548 4.108zM30.06 7.472l.32-6.458c1.828.09 3.61.353 5.33.776l-1.548 6.28c-1.323-.326-2.694-.53-4.1-.598zm20.468 22.59l6.458.318c-.09 1.828-.353 3.61-.776 5.33l-6.28-1.548c.326-1.323.53-2.694.598-4.1zm-22.59 20.466l-.318 6.458c-1.828-.09-3.61-.353-5.33-.776l1.548-6.28c1.323.326 2.694.53 4.1.598zM7.473 27.938l-6.458-.318c.09-1.828.353-3.61.776-5.33l6.28 1.548c-.325 1.323-.53 2.694-.597 4.1zm33.14-17.1l3.483-5.448c3.338 2.14 6.192 4.966 8.363 8.28l-5.414 3.538c-1.67-2.55-3.866-4.724-6.433-6.37zm6.55 29.774l5.448 3.483c-2.14 3.338-4.965 6.192-8.28 8.363l-3.537-5.413c2.55-1.67 4.724-3.866 6.37-6.433zm-29.774 6.55l-3.484 5.448c-3.338-2.14-6.192-4.966-8.363-8.28l5.413-3.538c1.67 2.55 3.866 4.724 6.433 6.37zm-6.55-29.774l-5.45-3.483c2.14-3.338 4.966-6.192 8.28-8.363l3.538 5.413c-2.55 1.67-4.724 3.866-6.37 6.433z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.85,
    cy: 18.85,
    rx: 18.85,
    ry: 18.85,
    fill: "#000",
    fillOpacity: 0.2,
    transform: "translate(10.15 10.15)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 30)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 27.55,
    fill: "#05AE29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M24.085 8.01L22.61 1.712c1.725-.402 3.51-.645 5.34-.712l.243 6.462c-1.408.05-2.78.238-4.108.548zM49.99 24.085l6.298-1.474c.402 1.726.645 3.51.712 5.34l-6.462.244c-.05-1.408-.238-2.78-.548-4.108zM33.915 49.99l1.474 6.298c-1.726.402-3.51.645-5.34.712l-.244-6.462c1.408-.05 2.78-.238 4.108-.548zM8.01 33.915L1.712 35.39c-.402-1.725-.645-3.51-.712-5.34l6.462-.243c.05 1.408.238 2.78.548 4.108zM30.06 7.472l.32-6.458c1.828.09 3.61.353 5.33.776l-1.548 6.28c-1.323-.326-2.694-.53-4.1-.598zm20.468 22.59l6.458.318c-.09 1.828-.353 3.61-.776 5.33l-6.28-1.548c.326-1.323.53-2.694.598-4.1zm-22.59 20.466l-.318 6.458c-1.828-.09-3.61-.353-5.33-.776l1.548-6.28c1.323.326 2.694.53 4.1.598zM7.473 27.938l-6.458-.318c.09-1.828.353-3.61.776-5.33l6.28 1.548c-.325 1.323-.53 2.694-.597 4.1zm33.14-17.1l3.483-5.448c3.338 2.14 6.192 4.966 8.363 8.28l-5.414 3.538c-1.67-2.55-3.866-4.724-6.433-6.37zm6.55 29.774l5.448 3.483c-2.14 3.338-4.965 6.192-8.28 8.363l-3.537-5.413c2.55-1.67 4.724-3.866 6.37-6.433zm-29.774 6.55l-3.484 5.448c-3.338-2.14-6.192-4.966-8.363-8.28l5.413-3.538c1.67 2.55 3.866 4.724 6.433 6.37zm-6.55-29.774l-5.45-3.483c2.14-3.338 4.966-6.192 8.28-8.363l3.538 5.413c-2.55 1.67-4.724 3.866-6.37 6.433z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.85,
    cy: 18.85,
    fill: "#000",
    fillOpacity: 0.2,
    rx: 18.85,
    ry: 18.85,
    transform: "translate(30.15 40.15)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChips);
export default __webpack_public_path__ + "static/media/chips.080c34f68238343ef2f550f9746fddab.svg";
export { ForwardRef as ReactComponent };